require('/ui/components/toggle/toggle.module.scss.module.css');

export const toggle = "_toggle_1w0gn_1";
export const input = "_input_1w0gn_1";
export const wrapper = "_wrapper_1w0gn_1";
export const knob = "_knob_1w0gn_1";
export const rail = "_rail_1w0gn_1";
